import React, { useCallback, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TopChartFilters from "@client.components/TopChartFilters";
import { TopMeetingTimeParticipants } from "@client.components/Charts";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import LeftSideBar from "../LeftSideBar";
import TimeMeetingParticipantsDataTable from "../TimeMeetingParticipantsDataTable";
import { setReportsError } from "../reducer";
import "../Reports.scss";

const ReportsParticipants = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const filter = useSelector(makeFilter);
  const dispatch = useDispatch();

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.reports"));
  }, [t, setTopBarTitle]);

  const setPageError = useCallback(
    (err) => {
      dispatch(setReportsError(err));
    },
    [dispatch]
  );

  return (
    <div className="reports">
      <LeftSideBar />
      <div className="reports-content">
        <TopChartFilters />
        <div className="charts">
          <div className="chart-grid">
            <TopMeetingTimeParticipants
              filter={filter}
              onError={setPageError}
            />
            <TimeMeetingParticipantsDataTable filter={filter} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsParticipants;
